import {BaseElement} from '../base-element';
import {defineBentoElement} from '../../../../src/preact/bento-ce';

function defineElement(win) {
  defineBentoElement("bento-selector", BaseElement, win);
}

export {defineElement};